// Route for the canonical product URL — shows the default variant.
// Shape is frozen in ARCHITECTURE.md §4: /product/{slug}.
// The {lang} prefix is kept per the existing i18n pattern (defer F-13).
export default '/@lang/product/@slug'
